export default "__VITE_PUBLIC_ASSET__079a2e83__"